import Image from "../images/products-image.png";

const Products = () => {
  return (
    <section className="bg-white w-full">
      <div className="flex flex-col lg:flex-row bg-gradient-to-r from-stone-300 to-orange-50 shadow-lg overflow-hidden py-8 min-h-[500px]">
        
        {/* Left: Text Content */}
        <div className="w-full lg:w-2/3 p-6 md:p-12 lg:p-16 flex flex-col justify-center">
          <h2 id="products" className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6 text-sky-950">
            Products & Services
          </h2>

          <div className="space-y-6 md:space-y-8 text-gray-700 text-base md:text-lg lg:text-xl xl:text-2xl text-justify">
            <div>
              <h6 className="text-lg md:text-xl lg:text-2xl font-bold text-sky-950 mb-3">Grain Trading:</h6>
              <p>
                Specializing in wheat, maize, michigan pea beans, soybeans, barley, and sorghum.
              </p>
            </div>

            <div>
              <h3 className="text-lg md:text-xl lg:text-2xl font-bold text-sky-950 mb-3">Logistics Solutions:</h3>
              <p>
                Offering end-to-end supply chain services, including storage, transportation, and shipping.
              </p>
            </div>

            {/* Market Research Section */}
            <div id="marketresearch">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6 text-sky-950 pt-8 md:pt-10">
                Market Research
              </h2>
              <p className="pl-2">
                Let's Trade Africa intends to reach every region in Zimbabwe, Malawi and South Africa. Our extensive network of buyers and sellers 
                allows us to navigate complex markets and meet the diverse needs of our global clientele.
              </p>
            </div>
          </div>
        </div>

        {/* Right: Image */}
        <div className="w-full lg:w-1/3 flex justify-center lg:justify-end">
          <img
            src={Image}
            alt="Products & Services"
            className="w-full max-w-[400px] md:max-w-[500px] lg:max-w-[450px] h-auto object-contain rounded-lg"
          />
        </div>

      </div>
    </section>
  );
};

export default Products;
